class A11y {
  constructor() {
    this.focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    this.triggers = document.querySelectorAll('.js-toggle-accessibility');
    this.textSizes = [100, 150, 200];
    this.breakpoints = {
      xs: 0,
      sm: 576 + 'px',
      md: 768 + 'px',
      lg: 992 + 'px',
      xl: 1200 + 'px',
      xxl: 1400 + 'px',
      xxxl: 2000 + 'px',
    };
    this.contrasts = ['orig', 'high'];
    this.forcedBreakpoint = false;
    this.data = {
      textSize: '100',
      contrast: 'orig',
    };
    this.active = false;
  }

  init() {
    return new Promise((resolve) => {
      this.bindListeners();
      this.resize();
      this.loadStorageData();
      this.setProperties();

      resolve();
    });
  }

  setProperties() {
    this.overlay = document.querySelector('#a11y');
    this.close = document.querySelectorAll('.a11y__close');
    this.trapFocus = new TrapFocus({ ele: this.overlay, activeClass: 'overlay--open' });
    this.bindTextSizeButtons();
    this.bindVisualStyleButtons();
  }

  resize() {
    this.setBreakpoints();
  }

  setBreakpoints() {
    let force = false;

    for (const [key, value] of Object.entries(this.breakpoints)) {
      if (window.matchMedia('(min-width: ' + value + ')').matches && !force) {
        document.querySelector('body').classList.add('bp-' + key);
        if (this.forcedBreakpoint == key) force = true;
      } else {
        document.querySelector('body').classList.remove('bp-' + key);
      }
    }
  }

  forceBreakpoint(breakpoint) {
    let force = false;
    this.forcedBreakpoint = breakpoint;

    for (const [key, value] of Object.entries(this.breakpoints)) {
      if (!force) {
        document.querySelector('body').classList.add('bp-' + key);
        if (breakpoint == key) force = true;
      } else {
        document.querySelector('body').classList.remove('bp-' + key);
      }
    }
  }

  resetBreakpoints() {
    this.forcedBreakpoint = false;
    this.setBreakpoints();
  }

  bindListeners() {
    const _this = this;

    window.addEventListener('resize', _this.resize.bind(_this));
    document
      .querySelector('body')
      ._addCustomEventListener('click', '.js-toggle-accessibility', _this.openOverlay.bind(_this));
    document.querySelector('body')._addCustomEventListener('click', '.a11y__close', _this.closeOverlay.bind(_this));
    document
      .querySelector('body')
      ._addCustomEventListener('click', '.a11y__skip-to-first', _this.scrollToFirstElement.bind(_this));
    document
      .querySelector('body')
      ._addCustomEventListener('click', '.a11y__skip-to-footer', _this.scrollToFooter.bind(_this));
    document.addEventListener('keydown', _this.keydownEventListener.bind(_this));
    document.addEventListener('_page_loaded', _this.setProperties.bind(_this));
  }

  bindTextSizeButtons() {
    const _this = this;

    document.querySelectorAll('.a11y__buttons--text-size button').forEach((button) => {
      let size = button.getAttribute('id').split('a11y__')[1];

      button.addEventListener(
        'click',
        function () {
          _this.setAriaSelected(button);
          _this.setTextSize(size);

          const event = document.createEvent('HTMLEvents');
          event.initEvent('resize', true, false);
          document.dispatchEvent(event);
        }.bind(_this)
      );
    });
  }

  bindVisualStyleButtons() {
    const _this = this;

    document.querySelectorAll('.a11y__buttons--visual-style button').forEach((button) => {
      let style = button.getAttribute('id').split('a11y__')[1];

      button.addEventListener(
        'click',
        function () {
          _this.setAriaSelected(button);
          _this.setVisualStyle(style);
        }.bind(_this)
      );
    });
  }

  setAriaSelected(button) {
    const parent = button.parentNode;

    parent.querySelector('[aria-selected="true"]').setAttribute('aria-selected', false);
    button.setAttribute('aria-selected', true);
  }

  setTextSize(size) {
    this.textSizes.forEach((s) => {
      document.querySelector('html').classList.remove('--a11y--' + s);
    });
    document.querySelector('html').classList.add('--a11y--' + size);

    this.setStorageData('textSize', size);

    if (size == 100) this.resetBreakpoints();
    else this.forceBreakpoint('lg');
  }

  setVisualStyle(style) {
    this.contrasts.forEach((s) => {
      document.querySelector('html').classList.remove('--a11y--' + s);
    });
    document.querySelector('html').classList.add('--a11y--' + style);

    this.setStorageData('contrast', style);
  }

  setStorageData(key, val) {
    if (!(key in this.data)) return;
    this.data[key] = val;
    localStorage.setItem('a11y', JSON.stringify(this.data));
  }

  loadStorageData() {
    if (localStorage.a11y) this.data = { ...this.data, ...JSON.parse(localStorage.a11y) };

    for (const [key, value] of Object.entries(this.data)) {
      const button = document.querySelector('#a11y__' + value);

      if (button) button.click();
    }
  }

  openOverlay(e) {
    this.refTrigger = e.targetElement;
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'true');
    });
    this.overlay._show(0.5);
    this.overlay.classList.add('overlay--open');
    this.overlay.querySelector('[aria-selected="true"]').focus();
    document.querySelector('html, body').classList.add('overlay--active');
  }

  closeOverlay() {
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
    this.overlay._hide(0.5).then(() => this.overlay.classList.remove('overlay--open'));
    this.refTrigger.focus();
    this.refTrigger = false;
    document.querySelector('html, body').classList.remove('overlay--active');
  }

  keydownEventListener(e) {
    const _this = this;
    let isOpen = this.overlay.classList.contains('overlay--open');

    if (!isOpen) return;

    switch (e.key) {
      case 'Escape':
        _this.closeOverlay();
        break;
    }
  }

  scrollToFooter() {
    const footer = document.querySelector('#mastfoot');
    let offset = 0;

    if (!window.matchMedia('(min-width: 1200px)').matches) offset = $('#masthead').innerHeight();

    WebitScrollTo.scrollTo({ element: '#mastfoot', offset: offset }).then(() => footer.focus());
  }

  scrollToFirstElement() {
    let firstElement = document.querySelector('.banner');
    let offset = 0;

    if (!window.matchMedia('(min-width: 1200px)').matches) offset = $('#masthead').innerHeight();

    if (!firstElement) firstElement = document.querySelector('main');

    WebitScrollTo.scrollTo({ element: '.banner', offset: offset }).then(() => firstElement.focus());
  }
}

window.a11y = new A11y();

(function (window, $) {
  $(document).ready(function () {
    a11y.init();
  });
})(window, jQuery);
